import { ConflictMarker } from '../Timeline.types';

/**
 * Counts the number of distinct conflict spans in a per-day marker map.
 * Each contiguous span begins with a 'Conflict-Start' (or is a stand-alone 'Conflict-Single'),
 * so counting those two markers yields the span count regardless of span length.
 */
export function countConflicts(markers: Map<string, ConflictMarker> | undefined): number {
    if (!markers) {
        return 0;
    }

    let count = 0;
    for (const marker of markers.values()) {
        if (marker === 'Conflict-Start' || marker === 'Conflict-Single') {
            count++;
        }
    }
    return count;
}
